import React from "react";
import "./formAssociadoPJ.scss";
import AssociarClienteExistente from "./screens/associarClienteExistente";
import DadosIniciais from "./screens/dadosIniciais";
import DeclaracoesEspecificas from "./screens/declaracoesEspecificas";
import DocumentosAnexos from "./screens/documentosAnexos";
import Resumo from "./screens/resumo";
import Conclusao from "./screens/conclusao";
import NavigationButtonsAssociado from './components/navigationButtons';
import FormButtons from './components/formButtons';
import defaultFormValues from "./defaultFormValues";

class FormAssociadoPJ extends React.Component {
  constructor(props) {
    super(props);
    const {
      associado,
      firstStep,
      conclusaoStep,
      navigation,
      addAssociadoAction,
      CodigoGerente,
    } = props;
    const _firstStep = associado && associado.IdCliente ? firstStep : navigation.Grupos[1];
    this.state = associado ? {
      clientExists: !!associado.IdCliente,
      client: !associado.IdCliente ? {} :
        { IdCliente: associado.IdCliente, Nome: associado.Nome, Cpf: associado.Cpf },
      currentStep: associado.done ? conclusaoStep : _firstStep,
      ...(associado.dadosCadastrais || defaultFormValues),
      tipoCadastro: { tipoProdutoValue: navigation.Id },
      currentValidation: null
    } : {
      clientExists: false,
      client: {},
      currentStep: firstStep,
      ...defaultFormValues,
      tipoCadastro: { tipoProdutoValue: navigation.Id },
      dadosIniciais: {
        ...defaultFormValues.dadosIniciais,
        form: {
          ...defaultFormValues.dadosIniciais.form,
          dadosIniciais_codigoGerente: CodigoGerente,
        },
      },
      currentValidation: null
    };
    this.nextStep = this.nextStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.updateState = this.updateState.bind(this);
    this.salvarAssociado = this.salvarAssociado.bind(this);
    const { tipoSocio, idSocio } = props;
    addAssociadoAction({ tipoSocio, idSocio });
  }

  componentWillUnmount() {
    const { tipoSocio, idSocio } = this.props;
    this.props.removeAssociadoAction(tipoSocio, idSocio);
  }
  
  nextStep() {  
    this.setState(({ currentStep }, { navigation }) => {
      const curStepIndex = navigation.Grupos.findIndex((step) => step.IdEsteira === currentStep.IdEsteira);
      const nextStep = navigation.Grupos[curStepIndex + 1];
      return { currentStep: nextStep, currentValidation: null };
    });
  };

  previousStep() {
    this.setState(({ clientExists, currentStep }, { navigation, firstStep }) => {
      if (clientExists) return { currentStep: firstStep };
      const curStepIndex = navigation.Grupos.findIndex((step) => step.IdEsteira === currentStep.IdEsteira);
      const previousStep = navigation.Grupos[curStepIndex - 1];
      return { currentStep: previousStep, currentValidation: null };
    });
  };

  updateState = (newState) => this.setState(newState);

  salvarAssociado = () => {
    const {
      clientExists,
      client,

      tipoCadastro,
      dadosIniciais,
      declaracoesEspecificas,
      documentosAnexos,
    } = this.state;

    const { tipoSocio, idSocio, camposResumo } = this.props;

    const clientToUpdate = { tipoSocio, idSocio, camposResumo };

    if (clientExists) {
      clientToUpdate.Nome = client.Nome;
      clientToUpdate.Cpf = client.Cpf;
      clientToUpdate.IdCliente = client.IdCliente;
      clientToUpdate.dadosCadastrais = null;
    }
    else
      clientToUpdate.dadosCadastrais = {
        tipoCadastro,
        dadosIniciais,
        declaracoesEspecificas,
        documentosAnexos,
      }

    this.props.updateAssociadoAction(clientToUpdate);
    
    this.setState((state, { conclusaoStep }) => {
      return { currentStep: conclusaoStep, currentValidation: null };
    });
  };

  render() {
    const {
      navigation: { Grupos: steps }
    } = this.props;
    const {
      currentStep,
      clientExists
    } = this.state;

    return (
      <section className="associado-container">
        <div className="breadcrumbs">
          <ul className="breadcrumbs-list">
            <li className={`breadcrumbs-list-item`}></li>
            {steps.map((s, i) => {
              let className = "breadcrumbs-list-item";
              if (s.IdEsteira === currentStep.IdEsteira) className += " breadcrumb-active";
              else if (s.IdEsteira < currentStep.IdEsteira) className += " breadcrumb-done";
              return (
                <li key={i} className={className}>{/* s.IdEsteira */}</li>
              );
            })}
          </ul>
          <h1 className="title">{currentStep.Nome}</h1>
          <span className="line"></span>
        </div>
        {(() => {
          switch (currentStep.IdEsteira) {
            case 0: return (
              <AssociarClienteExistente
                client={this.state.client}
                updateState={this.updateState}
                clientExists={clientExists}
              />
            );
            case 1: return (
              <DadosIniciais
                dadosIniciais={this.state.dadosIniciais}
                updateState={this.updateState}
                currentStep={currentStep}
              />
            );
            case 2: return (
              <DeclaracoesEspecificas
                declaracoesEspecificas={this.state.declaracoesEspecificas}
                updateState={this.updateState}
                currentStep={currentStep}
              />
            );
            case 3: return (
              <DocumentosAnexos
                documentosAnexos={this.state.documentosAnexos}
                updateState={this.updateState}
                currentStep={currentStep}
                dadosIniciais_tipoDocumento={this.state.dadosIniciais.dadosIniciais_tipoDocumento}
              />
            );
            case 4: return (
              <Resumo
                resumo={this.state}
                updateState={this.updateState}
                currentStep={currentStep}
              />
            );
            case 5: return (
              <Conclusao
                tipoSocio={this.props.tipoSocio}
                idSocio={this.props.idSocio}
              />
            );
            default: return <></>;
          }
        })()}
        <div className="col">
          {currentStep.IdEsteira !== 0 ? (
            <NavigationButtonsAssociado
              nextStep={this.nextStep}
              previousStep={this.previousStep}
              showNext={currentStep.IdEsteira < 5}
              showPrevious={currentStep.IdEsteira > 0}
              isLast={currentStep.IdEsteira === 4}
              onSave={this.salvarAssociado}
              onValidate={this.state.currentValidation}
            />
          ) : (
            <FormButtons
              firstOnClick={this.nextStep}
              disableFirst={clientExists}
              secondOnClick={this.salvarAssociado}
              disableSecond={!clientExists}
            />
          )}
        </div>
      </section>
    );
  }
}

export default FormAssociadoPJ;
